/**
 * URL modality wins over the session-persisted modality slug.
 */
export function resolvePreferredModalitySlug(
	urlSlug: string | null | undefined,
	sessionSlug: string | null | undefined
): string | null {
	const fromUrl = urlSlug?.trim() || null;
	if (fromUrl) {
		return fromUrl;
	}
	return sessionSlug?.trim() || null;
}

/**
 * Whether to (re)apply a URL preference (`?modality=` / `?part=`) onto jotai.
 *
 * - Apply when the course changes (pick up session / URL for the new course).
 * - Apply a URL slug once per course (tracked by `appliedUrlSlug`); do not
 *   keep re-applying while the param stays in the address bar, or a later
 *   manual selection would be overwritten.
 * - Do not re-apply on the same course without a new URL — that preserves a
 *   campus-disabled clear while keeping the session slug for later courses.
 */
export function shouldApplyUrlPreference({
	previousCourseId,
	courseId,
	urlSlug,
	appliedUrlSlug,
}: {
	previousCourseId: string | null;
	courseId: string | null;
	urlSlug: string | null | undefined;
	appliedUrlSlug: string | null;
}): boolean {
	const trimmedUrl = urlSlug?.trim() || null;
	if (previousCourseId !== courseId) {
		return true;
	}
	return trimmedUrl != null && trimmedUrl !== appliedUrlSlug;
}
